module.exports = __webpack_public_path__ + "img/04.9be4282c.svg";